import api from "@/api";
import useFingerprint from "@/composables/useFingerprint";

export default function useAnalytics() {
  const currentUrl = new URL(window.location.href);
  const { getFingerprint } = useFingerprint();

  const trackAffiliateLink = async (
    product_id = null,
    type = "click",
    affiliate_id = null
  ) => {
    const tracking_id =
      affiliate_id ||
      currentUrl.searchParams.get("aff") ||
      currentUrl.searchParams.get("ref");
    const utm_source = currentUrl.searchParams.get("utm_source");
    const fingerprint = await getFingerprint();

    try {
      await api.post("analytics/tracking", {
        type,
        product_id: product_id,
        affiliate_id: tracking_id,
        utm_source: utm_source,
        device_id: fingerprint.visitorId,
        current_url: currentUrl.href,
        referrer: currentUrl.searchParams.get("referrer") || document.referrer,
        user_agent: navigator?.userAgent,
      });
    } catch (e) {
      console.error(e.response.data.message);
    }
  };

  const removeAffiliateLink = async (
    old_tracking_id,
    status,
    new_tracking_id = null
  ) => {
    const fingerprint = await getFingerprint();

    try {
      await api.post("analytics/tracking/unlink", {
        type: "click",
        affiliate_id: old_tracking_id,
        overwritten_by: new_tracking_id,
        device_id: fingerprint.visitorId,
        status,
        current_url: currentUrl.href,
        referrer: currentUrl.searchParams.get("referrer") || document.referrer,
        user_agent: navigator?.userAgent,
      });
    } catch (e) {
      console.error(e.response.data.message);
    }
  };

  return { trackAffiliateLink, removeAffiliateLink };
}
